/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardediting2Inputs */

const en_toolcardediting2 = /** @type {(inputs: Toolcardediting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`editing…`)
};

const pt_toolcardediting2 = /** @type {(inputs: Toolcardediting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a editar…`)
};

/**
* | output |
* | --- |
* | "editing…" |
*
* @param {Toolcardediting2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardediting2 = /** @type {((inputs?: Toolcardediting2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardediting2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardediting2(inputs)
	return pt_toolcardediting2(inputs)
});
export { toolcardediting2 as "toolCardEditing" }